import React from 'react'

export default function CloseIcon() {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.667 6L18 7.333L13.333 12L18 16.667L16.667 18L12 13.333L7.333 18L6 16.667L10.667 12L6 7.333L7.333 6L12 10.667L16.667 6Z'
        fill='black'
      />
    </svg>
  )
}
